// Links with an href, enabled form controls, and elements whose tabindex isn't
// -1, so a container focusable only by tabindex="-1" (a dialog panel, say) is
// left out. A link or control with tabindex="-1" still matches.
export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
